import { render, staticRenderFns } from "./Group-Add-Favourite.vue?vue&type=template&id=2286b390&"
import script from "./Group-Add-Favourite.vue?vue&type=script&lang=js&"
export * from "./Group-Add-Favourite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports